/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_External_Code_HintInputs */

const en_case_field_external_code_hint = /** @type {(inputs: Case_Field_External_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The identifier assigned to this case in the client’s system.`)
};

const pt_br2_case_field_external_code_hint = /** @type {(inputs: Case_Field_External_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O identificador atribuído a este caso no sistema do cliente.`)
};

/**
* | output |
* | --- |
* | "The identifier assigned to this case in the client’s system." |
*
* @param {Case_Field_External_Code_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_external_code_hint = /** @type {((inputs?: Case_Field_External_Code_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_External_Code_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_external_code_hint(inputs)
	return pt_br2_case_field_external_code_hint(inputs)
});